import CityPageTemplate from "../city-template/CityPageTemplate";
import { scarboroughConfig } from "./data";

export default function ScarboroughPage() {
  return <CityPageTemplate config={scarboroughConfig} />;
}